import { APP_ENV } from '@utils/constants';
const envUrl = APP_ENV === 'live' ? 'www' : APP_ENV;
export const seoLinks = [
    {
        text: 'Immobilien verkaufen',
        url: `https://${envUrl}.immowelt.de/anbieten/immobilien-verkaufen`,
    },
    {
        text: 'Nachmieter suchen',
        url: `https://${envUrl}.immowelt.de/anbieten/nachmieter`,
    },
    {
        text: 'Gewerbeimmobilien',
        url: `https://${envUrl}.immowelt.de/anbieten/gewerbeimmobilien`,
    },
    {
        text: 'Wohnung inserieren',
        url: `https://${envUrl}.immowelt.de/anbieten/wohnung-inserieren`,
    },
    {
        text: 'Grundstück verpachten',
        url: `https://${envUrl}.immowelt.de/anbieten/grundstueck-verpachten`,
    },
    {
        text: 'Büro vermieten',
        url: `https://${envUrl}.immowelt.de/anbieten/buero-vermieten`,
    },
    {
        text: 'Immobilienanzeigen',
        url: `https://${envUrl}.immowelt.de/anbieten/immobilienanzeigen`,
    },
    {
        text: 'Immobilien vermieten',
        url: `https://${envUrl}.immowelt.de/anbieten/immobilien-vermieten`,
    },
    {
        text: 'Wohnung vermieten',
        url: `https://${envUrl}.immowelt.de/anbieten/wohnung-vermieten`,
    },
    {
        text: 'Wohnung verkaufen',
        url: `https://${envUrl}.immowelt.de/anbieten/wohnung-verkaufen`,
    },
    {
        text: 'Haus vermieten',
        url: `https://${envUrl}.immowelt.de/anbieten/haus-vermieten`,
    },
    {
        text: 'Haus verkaufen',
        url: `https://${envUrl}.immowelt.de/anbieten/haus-verkaufen`,
    },
    {
        text: 'Grundstück verkaufen',
        url: `https://${envUrl}.immowelt.de/anbieten/grundstueck-verkaufen`,
    },
];
export default seoLinks;
